import { useCallback } from 'react';
import { Flex, IconSearch } from '@banhala/ui-kit';
import type { SearchBarProps } from './types';
import { isNil } from '../../../../utils';
import { HTMLText } from '../../../HTMLText';
import { useOpenDeeplink } from '../../../../hooks';
import { useLogAnalyticsEvent } from '../../../../hooks/useLogAnalyticsEvent';

export const SearchBar = ({ body }: SearchBarProps) => {
  const item = body?.item ?? null;
  const logging = body?.logging ?? null;
  const { openDeeplink } = useOpenDeeplink();
  const logAnalyticsEvent = useLogAnalyticsEvent();

  const handlePress = useCallback(() => {
    if (item?.deeplink) {
      if (logging) {
        logAnalyticsEvent({
          name: 'CLICK_SEARCH_BAR_COMPONENT',
          analytics: logging.analytics,
          ably_only_log: logging.ably_only_log,
        });
      }
      openDeeplink(item.deeplink);
    }
  }, [openDeeplink, item?.deeplink, logging, logAnalyticsEvent]);

  if (isNil(item)) {
    return null;
  }

  const { placeholder, deeplink, border_color } = item;

  return (
    <Flex.Column padding={{ horizontal: 12 }}>
      <Flex.Row
        height={48}
        borderWidth={2}
        borderColorValue={border_color}
        borderRadius={4}
        alignItems="center"
        padding={{ horizontal: 10 }}
        onPress={handlePress}
        disabled={!deeplink}
      >
        <Flex padding={{ right: 4 }}>
          <IconSearch width={20} height={20} color="content_secondary" />
        </Flex>
        <HTMLText type="subtitle3" color="content_secondary">
          {placeholder}
        </HTMLText>
      </Flex.Row>
    </Flex.Column>
  );
};
